// extracted by mini-css-extract-plugin
export var dogimage = "SectionOurStoriesCarouselByTopic-module--dogimage--54f1d";
export var pagination = "SectionOurStoriesCarouselByTopic-module--pagination--7f725";
export var sectionheader = "SectionOurStoriesCarouselByTopic-module--sectionheader--9fafb";
export var swiper = "SectionOurStoriesCarouselByTopic-module--swiper--d8902";
export var swiperwrapper = "SectionOurStoriesCarouselByTopic-module--swiperwrapper--1592e";
export var title = "SectionOurStoriesCarouselByTopic-module--title--39ffe";